import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import { IDiscographyType } from "types/discographyType";
import TrackListItem from "pages/dashboard/overview/components/track-list-item";
import { SongWithUrls, ReleaseContainerWithUrls } from "types/response-type";
import DateConvert from "utils/dateConvert";

interface IProps {
  data: (SongWithUrls | ReleaseContainerWithUrls)[];
}
const ListView = ({ data }: IProps) => {
  const ArrowItem = () => {
    return (
      <Arrow>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="7"
          viewBox="0 0 6 7"
          fill="none"
        >
          <path
            d="M4.75 4.25L3 2.75L1.25 4.25"
            stroke="#909090"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="7"
          viewBox="0 0 6 7"
          fill="none"
        >
          <path
            d="M4.75 2.75L3 4.25L1.25 2.75"
            stroke="#909090"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </Arrow>
    );
  };
  return (
    <Container>
      <TableContainer>
        <thead>
          <tr>
            <th scope="col">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "9.4rem"
                }}
              >
                <Typography size="s" weight="semibold" mr="0.4">
                  Title
                </Typography>
                <ArrowItem />
              </div>
            </th>
            <th scope="col">
              <Typography size="s" weight="medium" mr="0.4">
                Type
              </Typography>
            </th>
            <th scope="col">
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography size="s" weight="semibold" mr="0.4">
                  No of Tracks
                </Typography>
                <ArrowItem />
              </div>
            </th>
            <th scope="col">
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography size="s" weight="semibold" mr="0.4">
                  Release Date
                </Typography>
                <ArrowItem />
              </div>
            </th>
            <th scope="col">
              <Typography size="s" weight="medium" mr="0.4">
                Status
              </Typography>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((data, i) => {
            return <TrackListItem data={data} key={i} />;
          })}
        </tbody>
      </TableContainer>
    </Container>
  );
};

export default ListView;

const Container = styled.div`
  @media only screen and (max-width: 769px) {
    position: relative;
    width: 90vw;
    overflow-x: scroll;
    overflow-y: auto;
  }
`;

const TableContainer = styled.table`
  margin-bottom: 6.4rem;
  width: 100%;
  color: white;
  border-collapse: collapse;

  @media only screen and (max-width: 769px) {
    width: 100rem;
  }

  tr {
    background-color: transparent;
    position: relative;
    &:nth-child(odd) {
      background-color: ${Colors.grey700};
    }
  }
  th {
    text-align: left;
    color: ${Colors.grey500};
    padding: 1.65rem 0;
    background-color: ${Colors.grey900};
    cursor: auto;
  }
  thead {
    position: relative;
  }

  td {
    color: #e4e4e4;
    padding: 1.2rem 0;
  }
  tbody {
    overflow-y: visible;
  }
`;

const Arrow = styled.div`
  display: flex;
  flex-direction: column;
`;
